module.exports = __webpack_public_path__ + "img/yangguang.5c2eed01.png";